const VideoPlayer = ({ videoUrl,thumbnailUrl  }) => {
  return (
    <div className="relative videowrapper w-1/2 mx-auto" >
      <video
        className="absolute top-0 left-0 w-full h-full"
        src={videoUrl}
        controls
        preload="metadata"
        poster={thumbnailUrl }      />
    </div>
  );
};

export default VideoPlayer;